import React from 'react';
import { Check, AlertCircle, Loader2 } from 'lucide-react';
import type { AutoSaveStatus } from '../../hooks/useAutoSave';

interface AutoSaveIndicatorProps {
    status: AutoSaveStatus;
    lastSavedAt: Date | null;
}

export const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
    status,
    lastSavedAt,
}) => {
    if (status === 'idle') return null;

    if (status === 'saving' || status === 'pending') {
        return (
            <span className="flex items-center gap-1.5 text-xs text-gray-400">
                <Loader2 className="h-3 w-3 animate-spin" />
                Saving...
            </span>
        );
    }

    if (status === 'error') {
        return (
            <span className="flex items-center gap-1.5 text-xs text-red-500">
                <AlertCircle className="h-3 w-3" />
                Save failed
            </span>
        );
    }

    if (status === 'saved' && lastSavedAt) {
        return (
            <span className="flex items-center gap-1.5 text-xs text-gray-400">
                <Check className="h-3 w-3" />
                Saved at {lastSavedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
        );
    }

    return null;
};
